import { marker as bitfToTranslate } from '@biesbjerg/ngx-translate-extract-marker';

export enum EOrderPaymentStatus {
  PAYMENT_PENDING = 'payment_pending',
  PAID = 'paid',
  PARTIALLY_REFUNDED = 'partially_refunded',
  REFUNDED = 'refunded',
  PARTIALLY_PAID = 'partially_paid',
}

bitfToTranslate(`ORDER.PAYMENT_STATUS.PAYMENT_PENDING`);
bitfToTranslate(`ORDER.PAYMENT_STATUS.PAID`);
bitfToTranslate(`ORDER.PAYMENT_STATUS.PARTIALLY_REFUNDED`);
bitfToTranslate(`ORDER.PAYMENT_STATUS.REFUNDED`);
bitfToTranslate(`ORDER.PAYMENT_STATUS.PARTIALLY_PAID`);

export enum EOrderFulfillmentStatus {
  UNFULFILLED = 'unfulfilled',
  FULFILLED = 'fulfilled',
  PARTIALLY_FULFILLED = 'partially_fulfilled',
  DELIVERED = 'delivered',
}

bitfToTranslate(`ORDER.FULFILLMENT_STATUS.UNFULFILLED`);
bitfToTranslate(`ORDER.FULFILLMENT_STATUS.FULFILLED`);
bitfToTranslate(`ORDER.FULFILLMENT_STATUS.PARTIALLY_FULFILLED`);
bitfToTranslate(`ORDER.FULFILLMENT_STATUS.DELIVERED`);

export enum EReturnStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  DENY = 'deny',
  RETURNEDINSTORE = 'returnedInStore',
  SENTTOLOGISTIC = 'sentToLogistic',
  RETURNED = 'returned',
  CLOSED = 'closed',
}

bitfToTranslate(`COMMON.STATUSES.PENDING`);
bitfToTranslate(`COMMON.STATUSES.ACCEPTED`);
bitfToTranslate(`COMMON.STATUSES.DENY`);
bitfToTranslate(`COMMON.STATUSES.RETURNED`);
bitfToTranslate(`COMMON.STATUSES.RETURNEDINSTORE`);
bitfToTranslate(`COMMON.STATUSES.SENTTOLOGISTIC`);

export enum ETicketStatus {
  NEW = 'new',
  IN_PROGRESS = 'pending',
  WAITING_FOR_DELIVERY = 'waiting',
  READY_FOR_SHIPMENT = 'shipment_ready',
  PACK_PREPARED = 'pack_prepared',
  SHIPMENT_REQUESTED = 'shipment_requested',
  GOODS_RECEIVED = 'received',
  READY_FOR_THE_CUSTOMER = 'ready',
  PACK_DELIVERED = 'delivered',
  SHIPPED = 'shipped',
  ERROR = 'error',
  CANCELED = 'voided',
}

bitfToTranslate(`COMMON.STATUSES.WAITING`);
bitfToTranslate(`COMMON.STATUSES.SHIPMENT_READY`);
bitfToTranslate(`COMMON.STATUSES.PACK_PREPARED`);
bitfToTranslate(`COMMON.STATUSES.SHIPMENT_REQUESTED`);
bitfToTranslate(`COMMON.STATUSES.RECEIVED`);
bitfToTranslate(`COMMON.STATUSES.READY`);
bitfToTranslate(`COMMON.STATUSES.DELIVERED`);
bitfToTranslate(`COMMON.STATUSES.VOIDED`);

export enum ETicketItemStatus {
  NEW = 'new',
  ERROR = 'error',
  CANCELED = 'voided',
  PRODUCT_UNAVAILABLE = 'unavailable',
  PRODUCT_AVAILABLE = 'available',
  RESERVED_GOODS = 'reserved',
  PACK_RECEIVED = 'received',
  SHIPMENT_REQUESTED = 'shipment_requested',
  PACK_SHIPPED_TO_CUSTOMER = 'customer_shipped',
  PACK_SHIPPED = 'shipped',
  PACK_READY = 'ready',
  DELIVERED_TO_THE_CUSTOMER = 'delivered',
  PICKING_PRESENT = 'picking_present',
  PICKING_MISSING = 'picking_missing',
  PACKING_MISSING = 'packing_missing',
}

bitfToTranslate(`COMMON.STATUSES.AVAILABLE`);
bitfToTranslate(`COMMON.STATUSES.UNAVAILABLE`);
bitfToTranslate(`COMMON.STATUSES.RESERVED`);
bitfToTranslate(`COMMON.STATUSES.CUSTOMER_SHIPPED`);
bitfToTranslate(`COMMON.STATUSES.PICKING_MISSING`);
bitfToTranslate(`COMMON.STATUSES.PACKING_MISSING`);

export type TStatus =
  | typeof EOrderPaymentStatus
  | typeof EOrderFulfillmentStatus
  | typeof EReturnStatus
  | typeof ETicketStatus;

export enum EStatusColor {
  GREY = 'grey',
  GREEN = 'green',
  YELLOW = 'yellow',
  RED = 'red',
  ORANGE = 'orange',
}
